<script>
export default {
    name:"p-toolbar",
    data() {
        return {
            showNavigation: false,
            dPhoto : this.photo
        }
    },
    props:['username', 'email', 'photo', 'tipo'],
    methods: {
       logout(){
           window.location = "logout.php"
       },
       edit(){
           window.location = "editar-usuario.php"
       },
       changePhoto(url){
           this.dPhoto = url;
       }
    },
    created: function(){
        this.$bus.$on('change-photo', this.changePhoto);
    }
}
</script>
<template>
    <header class="p-toolbar d-flex flex-row flex-wrap align-items-center" slot="toolbar">
        <button class="d-md-none">
            <svg version="1.1" viewBox="0 0 24 24" class="c-icon icon -left svg-icon svg-fill" ><path pid="0" d="M2 5h20v2H2V5zM2 11h20v2H2v-2zM2 17h20v2H2v-2z"></path></svg>
        </button>
        <section class="logo">
            <svg class="p-icon icon logo"><use xlink:href="#sprite-logo"/></svg>
        </section>
        <div class="greeting">
            <p class="greeting-name">Bem vindo
                <svg class="p-icon icon"><use xlink:href="#sprite-heart"/></svg>
                {{username}}
                <span v-if="tipo == 20" style="color: red">
                    &nbsp(CONTA DE TESTE)
                </span>
            </p>
        </div>
        <button class="p-button d-md-none">
            <svg version="1.1" viewBox="0 0 24 24" class="p-icon left svg-icon svg-fill" style="width: 15px; height: 15px;"><path pid="0" d="M22.853 14.222C23.615 13.06 24 11.806 24 10.5c0-1.194-.325-2.347-.966-3.428-.6-1.012-1.45-1.919-2.528-2.688C18.353 2.846 15.512 2 12.5 2s-5.853.847-8.006 2.384c-1.078.769-1.928 1.675-2.528 2.688C1.325 8.153 1 9.306 1 10.5c0 1.178.316 2.319.941 3.387a8.568 8.568 0 0 0 2.025 2.325c-.231 1.491-1.581 2.672-3.516 3.953a.998.998 0 0 0-.406 1.122.998.998 0 0 0 .956.712c2.819 0 5.281-.931 6.85-1.713a17.394 17.394 0 0 0 2.412-1.447 16.083 16.083 0 0 0 1.928.157c.181.2.381.394.603.572 1.128.922 2.622 1.431 4.206 1.431.441 0 .878-.041 1.306-.119.775.819 2.122 1.119 3.194 1.119.228 0 .428-.15.488-.369s-.034-.447-.228-.559a1.876 1.876 0 0 1-.788-1.322c1.294-.95 2.028-2.303 2.028-3.75 0-.537-.1-1.062-.294-1.559.05-.075.1-.147.147-.219zM10.172 16.8a1.002 1.002 0 0 0-.806.209c-.009.006-.947.766-2.456 1.509-.663.328-1.503.684-2.472.966.938-1.038 1.559-2.247 1.559-3.738 0-.319-.153-.619-.413-.809C3.918 13.725 3 12.146 3 10.5c0-1.672.944-3.266 2.656-4.491C7.472 4.712 9.903 4 12.5 4s5.028.712 6.844 2.009C21.057 7.234 22 8.828 22 10.5c0 .741-.181 1.459-.541 2.15a6.026 6.026 0 0 0-.253-.219C20.078 11.509 18.584 11 17 11s-3.078.509-4.206 1.431C11.638 13.378 11 14.647 11 16c0 .316.034.625.103.928a12.716 12.716 0 0 1-.931-.128zm10.009 2.284a.5.5 0 0 0-.225.416c0 .544.134.991.319 1.344-.575-.15-1.094-.413-1.366-.8a.504.504 0 0 0-.521-.201c-.45.103-.916.156-1.388.156-2.756 0-5-1.794-5-4s2.244-4 5-4 5 1.794 5 4c0 1.194-.663 2.319-1.819 3.084z"></path>
            </svg>
        </button>
        <!--<button class="p-button large d-xs-none featured-action">
            <svg version="1.1" viewBox="0 0 24 24" class="p-icon mr-1" style="width: 15px; height: 15px;"><path pid="0" d="M22.853 14.222C23.615 13.06 24 11.806 24 10.5c0-1.194-.325-2.347-.966-3.428-.6-1.012-1.45-1.919-2.528-2.688C18.353 2.846 15.512 2 12.5 2s-5.853.847-8.006 2.384c-1.078.769-1.928 1.675-2.528 2.688C1.325 8.153 1 9.306 1 10.5c0 1.178.316 2.319.941 3.387a8.568 8.568 0 0 0 2.025 2.325c-.231 1.491-1.581 2.672-3.516 3.953a.998.998 0 0 0-.406 1.122.998.998 0 0 0 .956.712c2.819 0 5.281-.931 6.85-1.713a17.394 17.394 0 0 0 2.412-1.447 16.083 16.083 0 0 0 1.928.157c.181.2.381.394.603.572 1.128.922 2.622 1.431 4.206 1.431.441 0 .878-.041 1.306-.119.775.819 2.122 1.119 3.194 1.119.228 0 .428-.15.488-.369s-.034-.447-.228-.559a1.876 1.876 0 0 1-.788-1.322c1.294-.95 2.028-2.303 2.028-3.75 0-.537-.1-1.062-.294-1.559.05-.075.1-.147.147-.219zM10.172 16.8a1.002 1.002 0 0 0-.806.209c-.009.006-.947.766-2.456 1.509-.663.328-1.503.684-2.472.966.938-1.038 1.559-2.247 1.559-3.738 0-.319-.153-.619-.413-.809C3.918 13.725 3 12.146 3 10.5c0-1.672.944-3.266 2.656-4.491C7.472 4.712 9.903 4 12.5 4s5.028.712 6.844 2.009C21.057 7.234 22 8.828 22 10.5c0 .741-.181 1.459-.541 2.15a6.026 6.026 0 0 0-.253-.219C20.078 11.509 18.584 11 17 11s-3.078.509-4.206 1.431C11.638 13.378 11 14.647 11 16c0 .316.034.625.103.928a12.716 12.716 0 0 1-.931-.128zm10.009 2.284a.5.5 0 0 0-.225.416c0 .544.134.991.319 1.344-.575-.15-1.094-.413-1.366-.8a.504.504 0 0 0-.521-.201c-.45.103-.916.156-1.388.156-2.756 0-5-1.794-5-4s2.244-4 5-4 5 1.794 5 4c0 1.194-.663 2.319-1.819 3.084z"></path>
            </svg>
            <span class="text">Fale conosco</span>
        </button>-->
        <a href="/Manual.pdf" class="a-toolbar featured-action" target="_blank">Manual de Utilização</a>
        <div class="user-navigation" @click="showNavigation = !showNavigation">
            <!-- <div :title="username" class="p-avatar avatar" style="background-image: url('https://image.flaticon.com/icons/png/512/149/149071.png')"> -->
            <div :title="username" class="p-avatar avatar">
                <img :src="dPhoto" alt="USER" class="image">
            </div>
            <svg class="p-icon icon" :class="{active:showNavigation}"><use xlink:href="#sprite-arrow-down"/></svg>
            <transition name="fade-fast">
                <div v-if="showNavigation" class="navigation">
                    <div class="header d-flex align-items-center">
                        <!-- <div :title="username" class="p-avatar avatar" style="background-image: url('https://image.flaticon.com/icons/png/512/149/149071.png')"> -->
                        <div :title="username" class="p-avatar avatar">
                            <img :src="dPhoto" alt="USER" class="image">
                        </div>
                        <div class="content">
                            <h2 class="text-primary">{{username}}</h2>
                            <p> {{ email }} </p>
                        </div>
                    </div>
                        <hr class="separator m-0">
                        <div class="footer p-2 d-flex justify-content-end align-items-center">
                            <button @click="edit" style="margin-right : 4px" class="btn btn-sm btn-primary">Visualizar Perfil</button>
                            <button @click="logout" class="btn btn-sm btn-primary">Sair</button>
                        </div>
                </div>
            </transition>
        </div>
    </header>
</template>
<style lang="scss">
    .a-toolbar {
        text-decoration: none !important;
        color: #000000;
        margin-right: 24px;
        :hover
        {
             text-decoration:none;
             cursor:pointer;
        }
    }
</style>



// WEBPACK FOOTER //
// src/js/components/p-toolbar.vue